import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { intlShape } from 'react-intl'

import '../../utils/stringUtils'
import appConst from '../../constant/appConst'

import hiResLogo from '../../resources/img/logo-hires.png'
import reward from '../../resources/img/logo-qobuzissime.png'
import { getAlbum as getAlbumAction, getMoreTracksAlbum } from './albumActions'
import * as selectors from './albumSelectors'
import { Link } from 'react-router'
import TrackList from '../../components/tracklist/TrackList'
import redirectToApp from '../../utils/redirectToApp'
import Loader from '../../components/loader/Loader'

import { clearPlayqueue as clearPlayqueueAction } from '../../components/miniPlayer/AudioPlayer/playerActions'
import * as playerSelectors from '../../components/tracklist/trackListSelectors'
import { Helmet } from 'react-helmet'


const fields = (shouldDisplayArtist) => {
	const displayFields = [{
		type: 'number',
		render: track => <span>{track.track_number}</span>
	},{
		type: 'name',
		render: track => <Link to={`/track/${track.id}`}>{track.title}</Link>
	}]

	if (shouldDisplayArtist) {
		displayFields.push(
			{
				type: 'artist',
				render: track => {
					let artistId = ''
					let artistName = ''

					if (track.id && track.performer) {
							artistId = track.performer.id
							artistName = track.performer.name
					}
					return (<Link to={`/artist/${artistId}`}>{artistName}</Link>)
				}
			}
		)
	}

	displayFields.push({
		type: 'time',
		render: track => `${`0${Math.floor(track.duration / 60)}`.substr(-2)}:${`0${track.duration % 60}`.substr(-2)}`
	})

	return displayFields
}



class AlbumPage extends PureComponent {

	componentWillMount() {
		const { id, getAlbum } = this.props
		getAlbum(id)
		this.state = {
			fullDescription: false
		}
		this.toggleFullDescription = this.toggleFullDescription.bind(this)
		this.showMore = this.showMore.bind(this)
	}

	componentWillUnmount() {
		this.props.clearPlayqueue()
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.id !== nextProps.id) this.props.clearPlayqueue()
	}


	toggleFullDescription() {
		this.setState({
			fullDescription: !this.state.fullDescription
		})
	}

	showMore() {
		const { id, trackListOffset, getMoreTracks } = this.props
		getMoreTracks(id, trackListOffset + appConst.trackListLoadStep)
	}

	render() {
		const { id, pochette, title, artist, nbPistes, hires, duree, description, isQobuzissime, orderUrl, shouldDisplayArtist } = this.props
		const { intl } = this.context

		let dureeAffichee
		if (duree > 3600) {
			dureeAffichee = intl.formatMessage(
				{ id: 'infos.duration.long' },
				{ hours: `${Math.floor(duree/3600)}`, minutes: `${Math.floor((duree % 3600)/60)}` }
			)
		} else {
			dureeAffichee = intl.formatMessage(
				{ id: 'infos.duration.short' },
				{ minutes: `${Math.floor(duree/60)}`, seconds: `${duree % 60}` }
			)
		}

		const showDisplayFull = !this.state.fullDescription && (description || '').length > appConst.descriptionMaxLength

		return (
			<Loader>
				<div className="content mt40">
					<Helmet>
						<title>{intl.formatMessage({ id: "title.album" }, { albumName: title, artistName: artist.name })}</title>
					</Helmet>
					<div className="album-background" style={{ backgroundImage: `url(${pochette})` }} />
					<div className="album-background-overlay" />
					<div className="container">
						<div className="row">
							<div className="col-md-12">
								<div className="album-cover-content">
									<img className="album-cover" src={pochette} alt={title} />
									{hires && <span className="hi-res-quality">
										<img src={hiResLogo} alt={intl.formatMessage({ id: 'infos.hires' })} height={35} width={35} />
									</span>}
								</div>
								<div className="text-center mb50">
									<h1 className="t4 text-bold mb10">{title}</h1>
									<p className="t2 c8 mb15"><Link to={`/artist/${artist.id}`}>{artist.name}</Link></p>
									<p className="c2 mb20">
										<span className="pct pct-track" /> {intl.formatMessage({ id: 'infos.trackCount' }, { count: `${nbPistes}` })}
										<span className="pct pct-circle-wait ml10" /> {dureeAffichee}
									</p>
									<a onClick={() => redirectToApp('album', id)} className="bt7">{intl.formatMessage({ id: 'buttons.listen' })}</a>
									<p className="mt10 t5">
										{orderUrl && <a href={`${appConst.albumOderUrl}${id}`} target="_blank" className="c2">
											<span className="pct pct-buy"/> {intl.formatMessage({ id: 'buttons.buy' })}
										</a>}
									</p>
								</div>
								{(description && description.length > 0) &&
									<div className="album-desc mb80">
										{isQobuzissime && <img src={reward} height={55} width={108} className="album-reward" alt="Qobuzissime" />}
										<p {...(!this.state.fullDescription ? { className: 'album-desc-content' } : { style: { paddingTop: '5px' } })} dangerouslySetInnerHTML={{ __html: (description ? `${description}` : '').nl2br() }} />
										{showDisplayFull && <p>
											<a onClick={this.toggleFullDescription} className="c2">
												{intl.formatMessage({ id: 'buttons.readmore' })}
												&nbsp;<span className="pct pct-carret-link t7" />
											</a>
										</p>}

										{this.state.fullDescription && <p>
											<a onClick={this.toggleFullDescription} className="c2">
												<span className="pct pct-reverse-carret-link t7" />&nbsp;
												{intl.formatMessage({ id: 'buttons.showless' })}
											</a>
										</p>}
									</div>
								}
								<div className="item-list">
									<h2 className="t2 c2 mb20">{intl.formatMessage({ id: 'tracklist.title.album' })}</h2>
									<TrackList
										fields={fields(shouldDisplayArtist)}
										listContainerClassName="album-tracks-list"
										listClassName={`track-list ${shouldDisplayArtist ? 'full' : 'full-name'} no-cache no-more`}
										moreItemsCallback={this.showMore}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</Loader>
		)
	}

}

AlbumPage.propTypes = {
	id: PropTypes.string,
	idTrack: PropTypes.string,
	pochette: PropTypes.string,
	title: PropTypes.string,
	artist: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string
	}),
	nbPistes: PropTypes.number,
	hires: PropTypes.bool,
	duree: PropTypes.number,
	getAlbum: PropTypes.func,
	getMoreTracks: PropTypes.func,
	description: PropTypes.string,
	isQobuzissime: PropTypes.bool,
	orderUrl: PropTypes.string,
	trackListOffset: PropTypes.number,
	shouldDisplayArtist: PropTypes.bool
}

AlbumPage.contextTypes = {
	intl: intlShape
}

const mapStateToProps = (state, ownProps) => ({
	id: ownProps.params.id,
	pochette: selectors.getPochette(state),
	title: selectors.getTitle(state),
	artist: selectors.getArtist(state),
	nbPistes: selectors.getNbPistes(state),
	hires: selectors.isHires(state),
	duree: selectors.getDuree(state),
	description: selectors.getDescription(state),
	isQobuzissime: selectors.isQobuzissime(state),
	orderUrl: selectors.getOrderUrl(state),
	trackListOffset: playerSelectors.getTrackListOffset(state),
	shouldDisplayArtist: selectors.shouldDisplayArtist(state)
})

const actions = {
	getAlbum: getAlbumAction,
	getMoreTracks: getMoreTracksAlbum,
	clearPlayqueue: clearPlayqueueAction
}

export default connect(mapStateToProps, actions)(AlbumPage)



// WEBPACK FOOTER //
// ./src/pages/album/AlbumPage.jsx